import {Component} from "../component";

export class JoyCards extends Component {
}
window.customElements.define('app-joy-cards', JoyCards);
